module.exports = __webpack_public_path__ + "zm.8fa757b31d6e83f467a2.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/zm.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/zm.svg
// module chunks = styles